exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spec-table[data-v-51cda058]{width:100%;font-size:12px}.spec-table td[data-v-51cda058]{padding:3px}.list p[data-v-51cda058]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0}.list[data-v-51cda058]:nth-child(2n){background:#f7f7f7}\n", ""]);

// exports
